export default __webpack_public_path__ + "static/media/permitplanimg.74d0059e.png";